const config = {
  aws_project_region: 'us-east-1',
  aws_cloud_logic_custom: [
    {
      name: 'initialBamboo',
      endpoint: 'https://md0di04d1d.execute-api.us-east-1.amazonaws.com/dev',
      region: 'us-east-1'
    }
  ],
  aws_cognito_identity_pool_id:
    'us-east-1:625f4fb5-17ec-4f43-92bb-bc5917635377',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_RVN236tiF',
  aws_user_pools_web_client_id: 'qsmr1rspiej3n93e8t9mknkop',
  oauth: {},
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: []
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_appsync_graphqlEndpoint:
    'https://bcipqf4pebggxfzljg3aesgsvu.appsync-api.us-east-1.amazonaws.com/graphql',
  aws_appsync_region: 'us-east-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_user_files_s3_bucket:
    'foreverbamboo02d5d96158cd414aab981b8bf13e9f83052ca-dev',
  aws_user_files_s3_bucket_region: 'us-east-1'
};

export default config;
